import React from 'react';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../../../../components/with-label/WithLabel';
import CommonDropdown from '../../../../../../components/common-dropdown/CommonDropdown';
import useResonanceMessagesLinkSort from '../../../../../../hooks/useResonanceMessagesLinkSort';
import SortDropdown from '../../../../../../components/sort-dropdown/SortDropdown';
import { RESONANCE_MESSAGES_LIST_SIZE } from '../../../../../../constants';
import SearchInput from '../../../../../../components/common-inputs/SearchInput';
import GlobalPercentageSwitch from '../../../../global-percentage-switch/GlobalPercentageSwitch';

import scss from './HighPerformingVariablesFilters.module.scss';

function HighPerformingVariablesFilters({
  isGlobalPercentage,
  sort,
  size,
  onChangeSize,
  onChangeGlobalPercentage,
  onChangeSort,
  search,
  onChangeSearch,
}) {
  const { t } = useTranslation('resonance');

  const linksSortOptions = useResonanceMessagesLinkSort();

  const handleChangeSort = ({ sort, direction }) => {
    onChangeSort({ sort, direction });
  };

  const handleChangeSize = (newValue) => {
    onChangeSize(newValue);
  };

  return (
    <div className={scss.filtersWrapper}>
      <WithLabel label={`${t('search')}:`} variant={LABEL_STYLES.ROW} isBold maxWidth={240}>
        <SearchInput
          value={search}
          onChange={onChangeSearch}
          size='sm'
          name='top-messages-variables-search'
          key='top-messages-variables-search'
        />
      </WithLabel>

      <div className={scss.filtersBlock}>
        <WithLabel label={`${t('sort')}:`} variant={LABEL_STYLES.ROW} isBold maxWidth={200}>
          <SortDropdown
            options={linksSortOptions}
            sort={sort?.sort}
            direction={sort?.direction}
            onChange={handleChangeSort}
            name='top-messages-variables-sort'
            closeOnApply
          />
        </WithLabel>

        <WithLabel label={`${t('size')}:`} variant={LABEL_STYLES.ROW} isBold maxWidth={120}>
          <CommonDropdown
            options={RESONANCE_MESSAGES_LIST_SIZE}
            value={size}
            onSelect={handleChangeSize}
            name='top-messages-variables-size'
          />
        </WithLabel>

        <GlobalPercentageSwitch
          isGlobalPercentage={isGlobalPercentage}
          onChangeGlobalPercentage={onChangeGlobalPercentage}
        />
      </div>
    </div>
  );
}

export default HighPerformingVariablesFilters;
